import React from "react";
import { commaSeperated, displayUnit } from "../../utils/functions";
import Tooltip from "../Tooltip/Tooltip";

const TotalWealthValue = ({
  title,
  amount,
  unit,
  percentage,
  isGreen,
  containerStyle,
  infoLogo,
  TooltipContent,
}) => {
  return (
    <div
      style={{ ...containerStyle }}
      className="with_container_second_sub1_1 resp_width"
    >
      <div className="onest_1 ">
        <div className="value_container_words_1 blueTextColor">
          <p>{title}</p>
          {infoLogo && (
            <Tooltip
              infoLogo={infoLogo}
              ariaLabel={"Total Returns (IRR) Information"}
              tooltipClass={"main_page"}
            >
              {TooltipContent}
            </Tooltip>
          )}
          {/* // && (
          //   <div
          //     className="img_wrapper2"
          //     aria-describedby="tooltip-save"
          //   >
          //     <img
          //       className="money_info money-info-image"
          //       src={infoLogo}
          //       alt="info"
          //       tabIndex={0}
          //     />
          //     <div
          //     id={"tooltip-save"}
          //     role={"tooltip"}
          //       className={`tool main_page focus-tooltip ${isVisible ? "show-tooltip" : ""}`}
          //     >
          //       {TooltipContent}
          //     </div>
          //   </div>
          // )} */}
        </div>
        <div className="value_container_amount_1">
          {title === "Current Value" || title === "Invested Value" ? (
            <>
              <span className="value_amt_1 ">
                {/* {amount && Number(amount).toLocaleString("hi-IN")} */}

                {amount && commaSeperated(amount)}
              </span>
              <span className="value_unit_1 "> {displayUnit(unit)}</span>
            </>
          ) : isGreen ? (
            <>
              <span className="value_amt_1 value_red">
                {/* {amount && Number(amount).toLocaleString("hi-IN")} */}
                {amount && commaSeperated(amount)}
              </span>
              <span className="value_unit_1 value_red">
                {" "}
                {displayUnit(unit)}
              </span>
            </>
          ) : (
            <>
              <span className="is_green_amt">
                {amount && commaSeperated(amount)}
              </span>
              <span className="value_unit_green"> {displayUnit(unit)}</span>
            </>
          )}

          {percentage !== undefined && (
            <span
              className={
                Number(percentage) < 0
                  ? "percentage_amt background_red"
                  : "percentage_amt"
              }
            >
              {/* {NegativeNumber(percentage)} */}
              {!isNaN(percentage) ? (
                <span style={{ color: "white" }}>
                  {commaSeperated(percentage)}%
                </span>
              ) : (
                <span style={{ color: "white", padding: "0 10px" }}>-</span>
              )}
            </span>
          )}
        </div>
      </div>
      {/* <div className="2nd_2">
             some 2 
      </div> */}
    </div>
  );
};

export default TotalWealthValue;
